import { useParams } from 'react-router-dom'

import { useGetMergedJobSeekerQuery } from '../api'

/**
 * パラメータの求職者情報を取得する関数
 *
 * /job-seekers/:sfId 以下用。 JobSeekerLayoutで検証済みのためデータの存在は保証されている。
 *
 * @returns {{ sfId: string }}
 */
export const useCurrentJobSeeker = () => {
    const { sfId } = useParams()
    const { data } = useGetMergedJobSeekerQuery(sfId)
    return data
}
